// https://design.ramseysolutions.com/components/textarea/?tab=technologies#html-css
import textarea from '@ramsey-design-system/textarea/dist/scripts/textarea.js';

const textareaEls = document.querySelectorAll('[data-rds-textarea]');

textareaEls.forEach(textarea);
